import * as types from '../constants/ActionTypes'
import {handleActions} from 'redux-actions'

const reducers = {}
const initialState = {
	list: []
}

reducers[types.GET_DEPARTMENTS] = (state, action) => {
	return Object.assign({}, state, {isLoading: true, isLoaded: false, loadError: false})
}

reducers[types.GET_DEPARTMENTS_FINISH] = {
	next(state, action) {
		let departments = action.payload.departments.map(department => {
			let agents = department.agents.map(agent => Object.assign({}, agent, {unreadChatCount: 0}))
			return Object.assign({}, department, {agents: agents, unreadPeopleCount: 0})
		})
		return Object.assign({}, state, {
			list: departments,
			isLoading: false,
			isLoaded: true
		})
	},
	throw(state) {
		return Object.assign({}, state, {isLoading: false, loadError: true})
	}
}
reducers[types.SET_DEPARTMENT_AGENT_CHAT_COUNT] = {
	next(state = initialState, action){
		let departments = state.list.map(department => {
			let agents = department.agents.map(agent => {
				if (agent.fullUserId === action.payload.senderFullUserId) {
					agent.unreadChatCount++;

				}
				return agent;
			})
			return Object.assign({}, department, {
				agents: agents,
				unreadPeopleCount: agents.filter(agent => agent.unreadChatCount > 0).length
			})
		})
		return Object.assign({}, state, {list: departments})
	}
}
reducers[types.CHANGE_SELECTED_DEPARTMENT_AGENT] = {
	next(state = initialState, action){
		let departments = state.list.map(department => {
			let agents = department.agents.map(agent => {
				if (agent.fullUserId === action.payload.agentFullUserId) {
					agent.unreadChatCount = 0;

				}
				return agent;
			})
			return Object.assign({}, department, {
				agents: agents,
				unreadPeopleCount: agents.filter(agent => agent.unreadChatCount > 0).length
			})
		})
		return Object.assign({}, state, {list: departments})
	}
}

reducers[types.UPDATE_AGENT_LOGIN_STATE] = {
        next(state = initialState, action){
                let departments = state.list.map(department => {
                        let agents = department.agents.map(agent => {
                                if (agent.fullUserId === action.payload.fullUserId) {
                                        agent.isLoggedIn = action.payload.online;

                                }
                                return agent;
                        })
                        return Object.assign({}, department, {
                                agents: agents,
                        })
                })
                return Object.assign({}, state, {list: departments})
        }
}

reducers[types.UPDATE_AGENT_SERVICE_STATUS] = {
    next(state = initialState, action){
        let departments = state.list.map(department => {
            let agents = department.agents.map(agent => {
                if (agent._id === action.payload.agentId) {
                    agent.isServiceOn = action.payload.service;
                }
                return agent;
            })
            return Object.assign({}, department, {
                agents: agents,
            })
        })
        return Object.assign({}, state, {list: departments})
    }
}

export default handleActions(reducers, initialState)
